import { omit } from 'lodash-es';
import {
  DEFAULT_LEASE_ANNUAL_MILEAGE,
  LIMIT_TRADE_IN,
  LIMIT_DOWN_PAYMENT,
} from 'site-modules/shared/constants/calculator/calculator';
import { getAppLiedLimitAmount } from 'site-modules/shared/utils/calculator/calculator-helper';

export function mapLoanDataToRetailModel({
  calculationCriteria,
  loanMonthlyPaymentWithTaxes,
  loanMonthlyPayment,
  fees = {},
  taxes = {},
  limitCriteria,
}) {
  const { numberOfMonths, docFee, styleId, tradeIn, zipCode, salesPrice, downPayment } = calculationCriteria;
  // in case when we don't have taxes and fees available, set monthly payment as a base monthly payment w/o them
  const monthlyPaymentWithTaxes = loanMonthlyPaymentWithTaxes || loanMonthlyPayment;

  return {
    paymentWithTaxes: {
      monthlyPayment: monthlyPaymentWithTaxes,
      capitalizedFees: omit(fees, ['dmvFeesItemized']),
      capitalizedTaxes: taxes,
    },
    paymentWithoutTaxes: {
      baseMonthlyPayment: loanMonthlyPayment,
    },
    fees: omit(fees, ['dmvFeesItemized']),
    taxes,
    term: numberOfMonths,
    sellingPrice: salesPrice,
    docFee,
    monthlyPayment: monthlyPaymentWithTaxes,
    baseMonthlyPayment: loanMonthlyPayment,
    styleId,
    totalRebate: 0,
    tradeIn: getAppLiedLimitAmount({ limitCriteria }, LIMIT_TRADE_IN) || tradeIn,
    downPayment: getAppLiedLimitAmount({ limitCriteria }, LIMIT_DOWN_PAYMENT) || downPayment,
    zipCode,
    limitCriteria,
  };
}

export function mapLoanOffersToRetailModel(data, incentives = []) {
  return Object.keys(data).reduce((acc, cur) => {
    acc.push({ ...data[cur][0], term: Number(cur), annualMileage: DEFAULT_LEASE_ANNUAL_MILEAGE, incentives });
    return acc;
  }, []);
}

export const mapLoanAprsToLoanTermsFormat = offers =>
  offers.reduce(
    (purchaseOffersRes, { aprs = [], subtype, compatibleIncentiveIds = [], endDate }) => ({
      ...purchaseOffersRes,
      ...aprs.reduce(
        (result, { apr, termMonths }) => ({
          ...result,
          [termMonths]: [
            {
              apr,
              sourceTypeValue: subtype,
              compatibleSubprogramIds: compatibleIncentiveIds,
              term: Number(termMonths),
              annualMileage: DEFAULT_LEASE_ANNUAL_MILEAGE,
              endDate,
            },
          ],
        }),
        purchaseOffersRes
      ),
    }),
    {}
  );

export const mapLeaseDataToRetailModel = (
  {
    apr,
    dueAtSigningWithTaxes,
    fees = {},
    monthlyPayment,
    monthlyPaymentWithTaxes,
    netCapCost,
    nonCapitalizedTaxesAndFees,
    taxes = {},
    limitCriteria,
    tradeIn,
    totalLeaseCost,
  },
  zipCode
) => {
  // in case when we don't have taxes and fees available, set monthly payment as a base monthly payment w/o them
  const monthlyWithTaxes = monthlyPaymentWithTaxes || monthlyPayment;

  return {
    monthlyPayment: monthlyWithTaxes,
    dueAtSigning: dueAtSigningWithTaxes,
    netCapCost,
    apr,
    paymentWithTaxes: {
      monthlyPayment: monthlyWithTaxes,
      capitalizedFees: fees,
      capitalizedTaxes: taxes,
      amountFinanced: netCapCost,
      nonCapitalizedTaxesAndFees,
    },
    paymentWithoutTaxes: {
      baseMonthlyPayment: monthlyPayment,
    },
    tradeIn: getAppLiedLimitAmount({ limitCriteria }, LIMIT_TRADE_IN) || tradeIn,
    downPayment: getAppLiedLimitAmount({ limitCriteria }, LIMIT_DOWN_PAYMENT),
    limitCriteria,
    zipCode,
    totalLeaseCost,
  };
};
